import * as Yup from "yup";

export const initialValues = {
  branchCode: null,
  branchName: null,
  branchNameEn: null,
  branchAddressStatus: "N",
  address: null,
  addressEn: null,
  provinceId: null,
  districtId: null,
  subdistrictId: null,
  zipCode: null,
  branchCompensateStatus: "N",
  bankAccountNo: null,
  businessCode: null,
  insurancePersonRate: null,
  salaryNotOver: null,
};

const CompanyBranchSchema = Yup.object().shape({
  branchCode: Yup.string().required("Please enter your branch id."),
  branchName: Yup.string().required("Please enter your branch name (TH)."),
  branchNameEn: Yup.string().required("Please enter your branch name (EN)."),
  address: Yup.string().when("branchAddressStatus", {
    is: (val) => val,
    then: () =>
      Yup.string().required("Please enter your branch address detail (TH)."),
    otherwise: () => Yup.string().notRequired(),
  }),
  addressEn: Yup.string().when("branchAddressStatus", {
    is: (val) => val,
    then: () =>
      Yup.string().required("Please enter your branch address detail (EN)."),
    otherwise: () => Yup.string().notRequired(),
  }),
  provinceId: Yup.string().when("branchAddressStatus", {
    is: (val) => val,
    then: () => Yup.string().required("Please select."),
    otherwise: () => Yup.string().notRequired(),
  }),
  districtId: Yup.string().when("branchAddressStatus", {
    is: (val) => val,
    then: () => Yup.string().required("Please select."),
    otherwise: () => Yup.string().notRequired(),
  }),
  subDistrictId: Yup.string().when("branchAddressStatus", {
    is: (val) => val,
    then: () => Yup.string().required("Please select."),
    otherwise: () => Yup.string().notRequired(),
  }),
  zipCode: Yup.string().when("branchAddressStatus", {
    is: (val) => val,
    then: () =>
      Yup.number()
        .min(10000, "Invalid postal code.")
        .max(99999, "Invalid postal code.")
        .required("Please select."),
    otherwise: () => Yup.string().notRequired(),
  }),
});

export default CompanyBranchSchema;
